<template>
  <form
    class="brave-form"
    :action="action"
    method="POST"
    enctype="application/x-www-form-urlencoded"
    novalidate
    @submit.prevent="validate"
  >

    <md-progress-bar class="md-accent brave-form__progress" md-mode="indeterminate" v-if="sending" ></md-progress-bar>

    <slot></slot>


    <md-snackbar :md-active.sync="submitSuccess">{{submitSuccess}}</md-snackbar>
  </form>
</template>
<script>
export default {
  name: 'BraveFormTemplate',
  props: ['submitSuccess', 'validate', 'sending', 'action']
}
</script>

<style lang="scss" scoped>
  form {
    position: relative;
  }
</style>

<style lang="scss">
  /* Unscoped: VM uses position:relative on .md-progress-bar; fixed must win for full-bleed top bar. */
  .brave-form .brave-form__progress.md-progress-bar {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    width: 100vw !important;
    max-width: none !important;
    margin: 0 !important;
    z-index: 10050 !important;
    box-sizing: border-box;
  }
</style>